// extracted by mini-css-extract-plugin
export var description = "empty-attachments-module--description--hP1PY";
export var title = "empty-attachments-module--title--fViHz";
export var wrapper = "empty-attachments-module--wrapper--bbH+a";